<template>
  <div class="enterprise-list-page enterprise-list-page--appointment-statuses">
    <!-- Header Card -->
        <PageHeader icon="far fa-check-circle">
      <template #title>
        Status Perjanjian {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola daftar dan status alur perjanjian pasien
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/masters/appointment-statuses/add')"
                v-if="btn">
                <i class="fas fa-plus"></i>
                <span>Tambah Status</span>
              </b-button>
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <!-- Filter -->
            <div class="row justify-content-end appointment-status-toolbar">
              <div class="col-lg-4 col-md-6 col-12">
                <modern-search-input
                  v-model="filter.name"
                  fluid
                  placeholder="Cari nama status"
                  @keyup="filterByName"
                />
              </div>
            </div>

            <!-- Table -->
            <b-table
              striped
              hover
              class="mt-3"
              :items="items"
              :fields="fields"
              :style="'white-space: nowrap'"
              responsive="sm"
            >
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '15%' : '' }"
                />
              </template>
              <template #cell(color_class)="data">
                <div class="d-flex justify-content-start">
                  <button type="button" class="calendar-status-chip" :class="getChipClass(data.item.color_class)" style="pointer-events: none; margin: 0; box-shadow: none;">
                    <i v-if="getChipIcon(data.item.color_class)" :class="getChipIcon(data.item.color_class)"></i>
                    <span>{{ data.item.name }}</span>
                  </button>
                </div>
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="
                    $router.push({
                      path:
                        '/masters/appointment-statuses/detail/' + data.item.id,
                    })
                  "
                  ><i class="fas fa-eye px-0"></i
                ></b-button>
                <b-button
                  v-if="data.item.id > 5 && btn == true"
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="
                    $router.push({
                      path:
                        '/masters/appointment-statuses/edit/' + data.item.id,
                    })
                  "
                  ><i class="fas fa-edit px-0"></i
                ></b-button>
                <b-button
                  v-if="data.item.id > 5 && btn == true"
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  ><i class="fas fa-trash px-0"></i
                ></b-button>
              </template>
            </b-table>
            <b-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="mt-4"
            ></b-pagination>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import { debouncer } from "@/core/modules/Helper.js";
import module from "@/core/modules/CrudModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "List",

  components: {
    Card,
  },

  data() {
    return {
      // Filter
      filter: {
        name: "",
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "color_class",
          label: "Warna",
        },
        {
          key: "description",
          label: "Deskripsi",
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // user access
      btn: false,
      clinic_name:
        window.configuration == null
          ? "Medhop"
          : window.configuration.clinic_name,
    };
  },

  methods: {
    getChipClass(colorClass) {
      if (!colorClass) return 'calendar-status-chip--primary';
      if (colorClass.includes('primary')) return 'calendar-status-chip--primary';
      if (colorClass.includes('warning')) return 'calendar-status-chip--warning';
      if (colorClass.includes('success')) return 'calendar-status-chip--success';
      if (colorClass.includes('info')) return 'calendar-status-chip--info';
      if (colorClass.includes('danger')) return 'calendar-status-chip--danger';
      return 'calendar-status-chip--primary';
    },

    getChipIcon(colorClass) {
      if (!colorClass) return 'far fa-dot-circle';
      if (colorClass.includes('primary')) return 'far fa-dot-circle';
      if (colorClass.includes('warning')) return 'fas fa-exclamation-triangle';
      if (colorClass.includes('success')) return 'far fa-check-circle';
      if (colorClass.includes('info')) return 'far fa-paper-plane';
      if (colorClass.includes('danger')) return 'far fa-times-circle';
      return 'far fa-dot-circle';
    },

    pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      this.pagination();
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}`;
      let response = await module.paginate(
        "appointment-statuses",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;

      let a, b;
      b = this.perPage * (this.currentPage - 1) + 1;
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a;
      }

      this.items = response.data;
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1;
        this.pagination();
      }, 500);
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("appointment-statuses/" + id);
      // If Deleted
      if (result) {
        this.pagination();
      }
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "1802") {
          this.btn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Status Perjanjian" }]);
    // Get Data
    this.pagination();
    this.setActiveButton();
  },
};
</script>
